import { DEFAULT_ICON_PROPS, IIconProps } from './constants';

export const CheckboxIcon = ({
  ariaLabel = 'Checkbox mark',
  isGreen = false,
  ...props
}: IIconProps & { isGreen?: boolean }) => {
  const { size, width, height, title, ariaHidden, className, stroke, strokeWidth } = {
    ...DEFAULT_ICON_PROPS,
    ...{ strokeWidth: 0.2, stroke: undefined },
    ...props,
  };

  return (
    <svg
      data-testid="CheckboxIcon"
      width={size ?? width}
      height={size ?? height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={ariaLabel}
      aria-hidden={ariaHidden}
      className={`block ${className}`}
      {...props}
    >
      {title && <title>{title}</title>}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
        fill={isGreen ? '#00C795' : 'currentcolor'}
        strokeWidth={0}
      />
      <path
        d="M16.5219 8.06426C16.9292 7.65696 17.5896 7.65696 17.9969 8.06426C18.4042 8.47156 18.4042 9.13192 17.9969 9.53922L10.4935 17.0427C10.0862 17.45 9.4258 17.45 9.0185 17.0427L5.60784 13.632C5.20054 13.2247 5.20054 12.5643 5.60784 12.157C6.01514 11.7497 6.6755 11.7497 7.0828 12.157L9.75598 14.8302L16.5219 8.06426Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill={isGreen ? '#FFFFFF' : (stroke ?? '#FFFFFF')}
      />
    </svg>
  );
};
